import Python from './python.webp';
import Server from './server.webp';
import Socket from './socket.webp';

export default {
    Python,
    Server,
    Socket
}